"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrchestrationRuntimeStatus;
(function (OrchestrationRuntimeStatus) {
    OrchestrationRuntimeStatus["Running"] = "Running";
    OrchestrationRuntimeStatus["Completed"] = "Completed";
    OrchestrationRuntimeStatus["ContinuedAsNew"] = "ContinuedAsNew";
    OrchestrationRuntimeStatus["Failed"] = "Failed";
    OrchestrationRuntimeStatus["Canceled"] = "Canceled";
    OrchestrationRuntimeStatus["Terminated"] = "Terminated";
    OrchestrationRuntimeStatus["Pending"] = "Pending";
})(OrchestrationRuntimeStatus = exports.OrchestrationRuntimeStatus || (exports.OrchestrationRuntimeStatus = {}));
//# sourceMappingURL=orchestrationruntimestatus.js.map